import { UserProvider } from '@libs/contexts';
import { ErrorBoundary as NonCtxErrorBoundary } from '@libs/templates/template-pages';
import { GlobalStyle } from '@ps-smart-cp/ppfw-client';

export function ErrorBoundary() {
  return (
    <UserProvider>
      <GlobalStyle />
      <NonCtxErrorBoundary isUnderSubsystem={false} />
    </UserProvider>
  );
}
